<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        name: 'App'
    }
</script>

<style lang="scss">
    @import "./assets/scss/utils/_normalize.scss";
    @import "./assets/scss/utils/vars/_colors.scss";
    @import "./assets/scss/utils/vars/_fonts.scss";

    html {
        overflow: hidden;
    }


    body {
        color: $base-text-color;
        font-family: 'Gotham-Book';
        background-color: black;
    }

    img {
        max-width: 100%;
        max-height: 100%;
    }

    #app {
        width: 768px;
        height: 100vh;
        text-align: center;

        a {
            color: white;
            text-decoration: none;
        }
    }
</style>

